import { Star, Quote } from "lucide-react";

/**
 * PLACEHOLDER TESTIMONIALS - illustrative sample copy only.
 * These are not real customer reviews. Replace with genuine, permissioned
 * customer feedback before any public launch: publishing fabricated
 * testimonials is misleading conduct under Australian Consumer Law.
 */
export const PLACEHOLDER_REVIEWS = [
  {
    id: "r1",
    name: "Meagan T.",
    location: "Preston, VIC",
    detail: "Mum of two, one with a peanut allergy",
    stars: 5,
    quote:
      "The peanut recall text came through while I was actually standing in the aisle. I checked the jar in my trolley and put it straight back. I would never have seen it otherwise.",
  },
  {
    id: "r2",
    name: "Daniel K.",
    location: "Coorparoo, QLD",
    detail: "Dad of three",
    stars: 5,
    quote:
      "One short text, no app to open, no email buried in a promotions folder. My wife and I both get it and we know within a minute whether it matters to us.",
  },
  {
    id: "r3",
    name: "Priya S.",
    location: "Parramatta, NSW",
    detail: "Coeliac household",
    stars: 5,
    quote:
      "The gluten alerts are worded so plainly that my teenager understands them straight away. That matters more than I expected.",
  },
  {
    id: "r4",
    name: "Rachel M.",
    location: "Glenelg, SA",
    detail: "Family day care educator",
    stars: 5,
    quote:
      "I look after other people's children, so a listeria recall is not something I can afford to miss. The link goes straight to the official notice, which is what I need for my records.",
  },
];

const Stars = ({ count }) => (
  <div className="flex gap-0.5" aria-label={`${count} out of 5 stars`}>
    {Array.from({ length: count }).map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-amber-500 text-amber-500" />
    ))}
  </div>
);

export const Reviews = () => (
  <section className="border-t border-slate-200 bg-white" data-testid="reviews-section">
    <div className="mx-auto max-w-6xl px-5 py-20">
      <div>
        <p className="label-caps">What families say</p>
        <h2 className="mt-3 text-3xl font-bold tracking-tighter text-slate-900 sm:text-4xl lg:text-5xl">
          Built for the people
          <br className="hidden sm:block" /> doing the grocery shop
        </h2>
      </div>

      <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {PLACEHOLDER_REVIEWS.map((r) => (
          <figure
            key={r.id}
            data-testid={`review-${r.id}`}
            className="relative flex h-full flex-col rounded-2xl border border-slate-200 bg-slate-50 p-6 transition-transform duration-200 hover:-translate-y-1"
          >
            <Quote className="absolute right-5 top-5 h-6 w-6 text-slate-100" />
            <Stars count={r.stars} />
            <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-slate-700">"{r.quote}"</blockquote>
            <figcaption className="mt-5 border-t border-slate-100 pt-4">
              <p className="text-sm font-semibold text-slate-900">{r.name}</p>
              <p className="text-xs text-slate-500">{r.detail} - {r.location}</p>
            </figcaption>
          </figure>
        ))}
      </div>

      <p className="mt-6 text-xs text-slate-400" data-testid="reviews-disclaimer">
        Illustrative sample reviews shown during launch preparation.
      </p>
    </div>
  </section>
);
